/* eslint-disable implicit-arrow-linebreak */
// eslint-disable-next-line no-unused-vars
import React from 'react';
import { RolePermission } from 'src/components/sidebar';
import { useLocalStorage } from './useLocalStorage';

function useRolePermission() {
  const [roles] = useLocalStorage('roles', []);

  const currentRoles = roles.map((item: { roleName: string }) => item.roleName);

  const hasRolePermission = (role: RolePermission | RolePermission[]) => {
    let hasPermission = false;
    if (Array.isArray(role)) {
      (role as RolePermission[]).forEach(r => {
        if (currentRoles.includes(r)) {
          hasPermission = true;
        }
      });
    } else {
      hasPermission = currentRoles.includes(role);
    }
    return hasPermission;
  };

  return {
    hasRolePermission,
  };
}

export default useRolePermission;
